import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { QuizRenderer } from '@inso_web/quiz-previewer';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { QuizQuestion, QuizSettings } from '@inso_web/quiz-previewer/types';
import { quizApi } from '../api/client';

// Публичная страница: quiz.insoweb.ru/{slug}. Грузит published-версию.
// API возвращает { ok, quiz: { id, slug, titleRu, titleEn, questions, settings } }.
// QuizRenderer принимает questions и settings отдельно (не как один definition).

interface QuizResponse {
  ok: boolean;
  quiz: {
    id: string;
    slug: string;
    titleRu: string;
    titleEn: string;
    questions: QuizQuestion[];
    settings: QuizSettings;
  };
}

export function PublicQuizPage() {
  const { slug } = useParams<{ slug: string }>();

  const { data, isLoading, error } = useQuery({
    queryKey: ['public-quiz', slug],
    queryFn: () => quizApi.get<QuizResponse>(`/public/${slug}`).then((r) => r.data.quiz),
    enabled: !!slug,
    retry: 1,
  });

  if (isLoading) return <CenteredText>Loading…</CenteredText>;
  if (error || !data) return <CenteredText>Quiz not found</CenteredText>;

  const handleComplete = async (answers: Record<string, unknown>) => {
    await quizApi.post(`/public/${slug}/response`, { answers, metadata: {}, completedAt: new Date().toISOString() });
  };

  // Гарантируем что settings — объект (на случай если API вернул null/undefined)
  const settings: QuizSettings = data.settings ?? ({} as QuizSettings);

  return (
    <QuizRenderer
      questions={data.questions ?? []}
      settings={settings}
      quizId={data.id}
      lang="ru"
      onComplete={handleComplete}
    />
  );
}

function CenteredText({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif', color: '#666' }}>
      <p>{children}</p>
    </div>
  );
}
